import { API_URL } from '../../shared/actions'
import { customReducer } from './customReducer'

export const trainingCategoryReducer = (state, action) => {
  const {
    TRAININGCATEGORY: { GET_ALL_TRAININGCATEGORY, ADD_TRAININGCATEGORY, EDIT_TRAININGCATEGORY, DELETE_TRAININGCATEGORY },
  } = API_URL

  return customReducer(state, action, 'trainingCategories', [GET_ALL_TRAININGCATEGORY, ADD_TRAININGCATEGORY, EDIT_TRAININGCATEGORY, DELETE_TRAININGCATEGORY])
}

export const trainingCategoryContentReducer = (state, action) => {
  const {
    TRAININGCATEGORYCONTENT: { GET_ALL_TRAININGCATEGORYCONTENT, ADD_TRAININGCATEGORYCONTENT, EDIT_TRAININGCATEGORYCONTENT, DELETE_TRAININGCATEGORYCONTENT },
  } = API_URL

  return customReducer(state, action, 'trainingCategoryContents', [GET_ALL_TRAININGCATEGORYCONTENT, ADD_TRAININGCATEGORYCONTENT, EDIT_TRAININGCATEGORYCONTENT, DELETE_TRAININGCATEGORYCONTENT])
}

// CONTENT QUESTION

export const contentQuestionReducer = (state, action) => {
  const {
    CONTENTQUESTION: { GET_ALL_CONTENTQUESTION, ADD_CONTENTQUESTION, EDIT_CONTENTQUESTION, DELETE_CONTENTQUESTION },
  } = API_URL

  return customReducer(state, action, 'contentQuestions', [GET_ALL_CONTENTQUESTION, ADD_CONTENTQUESTION, EDIT_CONTENTQUESTION, DELETE_CONTENTQUESTION])
}
